"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  authenticationManager: true,
  AssertResultList: true,
  PermissionContext: true,
  UserManager: true,
  decodeIdToken: true,
  executeWhenVisible: true,
  consoleLogger: true
};
Object.defineProperty(exports, "AssertResultList", {
  enumerable: true,
  get: function () {
    return _permission.AssertResultList;
  }
});
Object.defineProperty(exports, "PermissionContext", {
  enumerable: true,
  get: function () {
    return _permission.PermissionContext;
  }
});
Object.defineProperty(exports, "UserManager", {
  enumerable: true,
  get: function () {
    return _userManager.UserManager;
  }
});
exports.authenticationManager = void 0;
Object.defineProperty(exports, "consoleLogger", {
  enumerable: true,
  get: function () {
    return _logger.consoleLogger;
  }
});
Object.defineProperty(exports, "decodeIdToken", {
  enumerable: true,
  get: function () {
    return _userManager.decodeIdToken;
  }
});
Object.defineProperty(exports, "executeWhenVisible", {
  enumerable: true,
  get: function () {
    return _concurrency.executeWhenVisible;
  }
});
var _webautoAuthCore = require("@tier4/webauto-auth-core");
var _webautoAuthRestapi = require("@tier4/webauto-auth-restapi");
var _constants = require("../constants");
var _SessionStorageStore = require("./SessionStorageStore");
var _TokenSourceWithOidc = require("./TokenSourceWithOidc");
var _error = require("./error");
Object.keys(_error).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _error[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _error[key];
    }
  });
});
var _permission = require("./permission");
var _singleSignOut = require("./singleSignOut");
var _userManager = require("./userManager");
var _concurrency = require("./concurrency");
var _logger = require("./logger");
const authenticationManager = _config => {
  const config = {
    response_type: "code",
    scope: "openid profile email",
    automaticSilentRenew: true,
    loadUserInfo: true,
    revokeTokensOnSignout: true,
    logLevel: "error",
    ..._config,
    logMethod: {
      ..._webautoAuthCore.noopLogger,
      ..._config.logMethod
    },
    bearerKeyName: _config.bearerKeyName ?? _constants.DEFAULT_BEARER_KEY_NAME,
    tokenServiceAPIUrl: _config.tokenServiceAPIUrl ?? "",
    permissionContext: {
      lifetime: 60,
      ..._config.permissionContext
    }
  };
  const logger = (0, _webautoAuthCore.leveledLogger)(config.logLevel, config.logMethod);
  logger.debug({
    caller: "authenticationManager",
    message: "setting up authenticationManager"
  });
  logger.debug({
    caller: "authenticationManager",
    message: `set up logger: level ${config.logLevel}`
  });
  const bearerStore = new _SessionStorageStore.SessionStorageStore(config.bearerKeyName);
  bearerStore.clear();
  const userManager = new _userManager.UserManager(config);
  userManager.events.addUserLoaded(() => {
    logger.debug({
      message: "oidc user loaded"
    });
  });
  userManager.events.addUserUnloaded(() => {
    logger.debug({
      message: "oidc: user unloaded"
    });
  });
  userManager.events.addAccessTokenExpired(() => {
    logger.debug({
      message: "oidc: access token expired"
    });
  });
  userManager.events.addSilentRenewError(async err => {
    logger.debug({
      message: `oidc: silent renew error ${err.message}`
    });
    await userManager.removeUser();
  });
  userManager.events.addUserUnloaded(() => {
    sessionStorage.removeItem(config.bearerKeyName);
  });
  (0, _singleSignOut.attachSingleSignOut)(userManager, config, logger);
  const getAxiosInstance = tokenSource => {
    return (0, _webautoAuthRestapi.createAxios)(logger, [(0, _webautoAuthRestapi.withBearerToken)(tokenSource)]);
  };
  function getOidcError() {
    const params = new URLSearchParams(location.search.substring(1));
    const code = params.get("error");
    const description = params.get("error_description");
    if (code && description) {
      return new _error.OidcCallbackError(code, description);
    }
    return null;
  }
  const tokenSvcClient = new _webautoAuthRestapi.InternalTokenServiceApi(new _webautoAuthRestapi.Configuration({}), config.tokenServiceAPIUrl, (0, _webautoAuthRestapi.createAxios)(logger));
  const tokenSource = new _TokenSourceWithOidc.TokenSourceWithOidc(new _webautoAuthRestapi.InternalTokenService(tokenSvcClient), userManager, bearerStore, logger);
  function getTokenSource() {
    return tokenSource;
  }
  const permissionContext = new _permission.PermissionContext(tokenSource, new _webautoAuthRestapi.InternalTokenService(tokenSvcClient), config.permissionContext.lifetime);
  return {
    getAxiosInstance,
    getOidcError,
    getTokenSource,
    userManager,
    permissionContext
  };
};
exports.authenticationManager = authenticationManager;
//# sourceMappingURL=index.js.map